function parse(value) {
  try {
    const parsedValue = JSON.parse(value)

    return parsedValue
  } catch (error) {
    console.warn('jsonUtils @ parse >>>>>', error)

    return null
  }
}

function stringify(value) {
  try {
    const stringifiedValue = JSON.stringify(value)

    return stringifiedValue
  } catch (error) {
    console.warn('jsonUtils @ stringify >>>>>', error)

    return null
  }
}

export const jsonUtils = {
  parse,
  stringify,
}
